import React, { useEffect } from 'react';
import withView from '../../docAutomation/withView';
import SarasRowSelector from "../../../../library/hooks/selector/SarasRowSelector";

const DocTableColumn = (props)=>{
    const {formObject, viewData, rowKey, rowID, reloadSearch} = props

    const renderDataColumn = (col, index) => {
        let DynamicComponent = formObject.viewMap[col.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vCMNGridLabel"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return <DynamicComponent formObject={formObject} viewData={col} rowKey={rowKey} 
            rowID={rowID} reloadSearch={reloadSearch}/>
        }
    }

    // console.log("viewData.rowValues", viewData.rowValues);

    return(
        Object.values(viewData.rowValues).sort((a, b) => a.sortKey - b.sortKey).map((col,index)=>(
            <td className={col.dataList.colCssClass} key={index}>{renderDataColumn(col,index)}</td>
        ))
    )
}

const DocTableData = (props)=>{
    const {formObject, viewData, reloadSearch, rowSelector} = props

    // console.log("table data", props);

    const initialiseActions = () => {
        // console.log("custom action set", formObject.dataList);
        if(formObject.dataList) {
            formObject.initialiseCustomActions(formObject.dataList.actionName, 
                formObject.dataList.depActions);
        }
    }

    useEffect(initialiseActions, [props.viewData]);
    
    if(viewData){
        return(
            <>
                {
                    Object.values(viewData).map((row, index)=>(
                        <tr key={index} className={row.dataList.cssClass}>
                            <SarasRowSelector useCheckBox rowSelector={rowSelector} rowID={row.dataList.dbRowId} customWrapper="td" wrapperClass="uiCol_Fixed uiCheckRowSelector" />
                            <DocTableColumn formObject={formObject} viewData={row} rowKey={row.rowKey} rowID={row.dataList.dbRowId} reloadSearch={reloadSearch}></DocTableColumn>
                        </tr>
                    ))
                }
            </>
        )
    }
    else return null;
}

export default withView(DocTableData, '', '', 0);
